import { CreateMixin } from "@pdfking/reactivity/preact"
import type { StringGUID } from "@pdfking/tfunc"
import { GuidToString, UUID } from "@pdfking/tfunc"

export const IDMixin = CreateMixin({
  computed: {
    uuid: () => `cmp-${GuidToString(UUID())}` as StringGUID,
  },
})
